(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["make-model-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('make-model-search')) {
    class MakeModelSearch extends HTMLElement {
      connectedCallback() {
        this._onChange = this._onChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._onClick = this._onClick.bind(this);
        this.addEventListener('change', this._onChange);
        this.addEventListener('submit', this._onSubmit);
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('submit', this._onSubmit);
        this.removeEventListener('click', this._onClick);
        if (this._abort) this._abort.abort();
      }

      get selects() {
        return Array.from(this.querySelectorAll('select[data-mms-select]'));
      }

      get map() {
        const el = this.querySelector('[data-mms-map]');
        if (!el) return [];
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return [];
        }
      }

      /** Build the filter.* query for the current dropdown state. */
      buildParams() {
        const params = new URLSearchParams();
        const splitParam = this.dataset.splitParam;
        let make = '';
        let model = '';

        for (const sel of this.selects) {
          const value = sel.value;
          if (!value) continue;
          const role = sel.dataset.role;
          if (role === 'make') make = value;
          else if (role === 'model') model = value;
          else params.append(sel.dataset.param, value);
        }

        if (splitParam) {
          if (model) {
            params.append(splitParam, model);
          } else if (make) {
            // No model chosen: search every value that belongs to this make (Shopify ORs them).
            this.map.filter((m) => m.make === make).forEach((m) => params.append(splitParam, m.v));
          }
        }

        // Keep the customer's chosen sort order when they are already on this collection.
        const current = new URLSearchParams(window.location.search);
        const sortBy = current.get('sort_by');
        if (sortBy && window.location.pathname.replace(/\/$/, '') === this.dataset.collectionUrl.replace(/\/$/, '')) {
          params.set('sort_by', sortBy);
        }
        return params;
      }

      /** Rebuild the Model dropdown from the embedded map (instant, no network). */
      _syncModelOptions() {
        const makeSel = this.querySelector('select[data-role="make"]');
        const modelSel = this.querySelector('select[data-role="model"]');
        if (!makeSel || !modelSel) return;
        const make = makeSel.value;
        const models = make ? this.map.filter((m) => m.make === make && m.model) : [];
        models.sort((a, b) => a.model.localeCompare(b.model, undefined, { numeric: true }));

        modelSel.innerHTML = '';
        const first = document.createElement('option');
        first.value = '';
        first.textContent = make ? modelSel.dataset.allLabel || 'All models' : modelSel.dataset.placeholder || 'Model';
        modelSel.appendChild(first);
        for (const m of models) {
          const opt = document.createElement('option');
          opt.value = m.v;
          opt.textContent = m.model;
          modelSel.appendChild(opt);
        }
        modelSel.disabled = !make;
      }

      _onChange(event) {
        const sel = event.target.closest('select[data-mms-select]');
        if (!sel) return;
        if (sel.dataset.role === 'make') this._syncModelOptions();
        this.refresh(sel.dataset.role);
      }

      /** Re-render this section for the current selection so every dropdown narrows. */
      async refresh(focusRole) {
        const params = this.buildParams();
        params.set('section_id', this.dataset.sectionId);
        const url = `${this.dataset.collectionUrl}?${params.toString()}`;

        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        this.classList.add('mms--loading');

        try {
          const response = await fetch(url, { signal: this._abort.signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('make-model-search');
          if (!fresh) throw new Error('Section markup not found');

          this.innerHTML = fresh.innerHTML;
          for (const attr of Array.from(fresh.attributes)) {
            if (attr.name.startsWith('data-')) this.setAttribute(attr.name, attr.value);
          }
          this.classList.toggle('mms--has-selection', fresh.classList.contains('mms--has-selection'));

          if (focusRole) {
            const again = this.querySelector(`select[data-role="${focusRole}"]`);
            if (again) again.focus({ preventScroll: true });
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('[make-model-search]', error);
        } finally {
          this.classList.remove('mms--loading');
        }
      }

      _onSubmit(event) {
        event.preventDefault();
        const query = this.buildParams().toString();
        window.location.assign(this.dataset.collectionUrl + (query ? `?${query}` : ''));
      }

      _onClick(event) {
        const reset = event.target.closest('[data-mms-reset]');
        if (!reset) return;
        event.preventDefault();
        window.location.assign(this.dataset.collectionUrl);
      }
    }
    customElements.define('make-model-search', MakeModelSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications-tab"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecsTabs extends HTMLElement {
    connectedCallback() {
      this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this._tabs.forEach((tab) => {
        tab.addEventListener('click', () => this._selectTab(tab));
        tab.addEventListener('keydown', (e) => this._handleKeydown(e));
      });
    }

    _selectTab(selectedTab) {
      this._tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
      });

      this._panels.forEach((panel) => {
        const isActive = panel.id === selectedTab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    _handleKeydown(event) {
      const index = this._tabs.indexOf(event.currentTarget);
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % this._tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + this._tabs.length) % this._tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this._tabs.length - 1;
      }

      if (nextIndex !== null) {
        event.preventDefault();
        this._selectTab(this._tabs[nextIndex]);
        this._tabs[nextIndex].focus();
      }
    }
  }

  customElements.define('product-specs-tabs', ProductSpecsTabs);

  } catch(e) { console.error(e); }
})();
})();
